module.exports = __webpack_public_path__ + "img/eraser1.ca18a299.webp";